/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Icon from 'storybookComponents/Icon';
import useStyles from "../style";
import { EmbedCodeIcon } from "icons/index";
import EmbedCodePoup from "storybookComponents/EmbededCodePopup";

import { getStatusColor } from "../util";

export const MenuList = React.memo(({
  item,
  onPreviewCallback,
  onDuplicateCallback
}) => {
  const classes = useStyles();
  const [menuanchorEl, setMenuAnchorEl] = useState(null);
  const [iconStroke, setIconStroke] = useState('#333');

  const openMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuAnchorEl(null);
  };

  const handleClick = () => {
    onDuplicateCallback(item)
    setMenuAnchorEl(null);
  }

  let codeLink = `<iframe src="${process.env.REACT_APP_hostName}/residential-banner/${item.id}" scrolling="no" style="width: 100%; border: none; height: 100vh;"/>`

  return (
    <>
      <IconButton
        aria-label='more'
        aria-haspopup='true'
        aria-controls='simple-menu'
        onClick={openMenu}
      >
        <MoreVertIcon className={classes.menuicon} />
      </IconButton>
      <Menu
        id='simple-menu'
        anchorEl={menuanchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        open={Boolean(menuanchorEl)}
        onClose={closeMenu}
        classes={{
          paper: classes.menuroot,
        }}
      >
        <MenuItem
          ListItemClasses={{
            button: classes.listbtn,
          }}
          onClick={handleClick}
        >
          <ListItemIcon
            classes={{
              root: classes.iconroot,
            }}
          >
            <Icon
              type='icon-single-copy-04'
              size='md'
              className={classes.normico}
            />
          </ListItemIcon>
          <Typography className={classes.menutext} variant='body1'>
            Duplicate
          </Typography>
        </MenuItem>
        <MenuItem
          ListItemClasses={{
            button: classes.listbtn,
          }}
          onClick={onPreviewCallback.bind(this, item)}
        >
          <ListItemIcon
            button='false'
            classes={{
              root: classes.iconroot,
            }}
          >
            <Icon type='icon-eye' size='md' className={classes.normico} />
          </ListItemIcon>
          <Typography className={classes.menutext} variant='body1'>
            Preview
          </Typography>

        </MenuItem>
        <MenuItem
          ListItemClasses={{
            button: classes.listbtn,
          }}
        >
          <EmbedCodePoup title={<div className={classes.popUpTitle}><b>Embed Code:</b> {item.title}</div>} codeLink={codeLink}>
            {
              (toggle) => (
                <div
                  className={classes.flexBox}
                  onMouseEnter={() => setIconStroke('#26BBED')}
                  onMouseLeave={() => setIconStroke('#333')}
                  onClick={toggle}
                >
                  <ListItemIcon
                    button='false'
                    classes={{
                      root: classes.iconroot,
                    }}
                  >
                    <EmbedCodeIcon stroke={iconStroke} fill="none" />
                  </ListItemIcon>
                  <Typography className={classes.menutext} variant='body1'>
                    Embed Code
                  </Typography>
                </div>
              )
            }
          </EmbedCodePoup>
        </MenuItem>
      </Menu>
    </>
  );
})


export const PreviewIcon = React.memo(({ stroke, fill }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.875 10.2084C1.875 10.2084 5.16667 5.20839 10.2083 5.20839C15.2083 5.20839 18.5417 10.2084 18.5417 10.2084C18.5417 10.2084 15.1667 15.2084 10.2083 15.2084C5.20833 15.2084 1.875 10.2084 1.875 10.2084Z'
      stroke='#333333'
      strokeMiterLimit='10'
      strokeLinecap='square'
    />
    <path
      d='M10.2083 11.8751C12.0493 11.8751 13.5417 10.3827 13.5417 8.54172C13.5417 6.70077 12.0493 5.20839 10.2083 5.20839C8.36738 5.20839 6.875 6.70077 6.875 8.54172C6.875 10.3827 8.36738 11.8751 10.2083 11.8751Z'
      stroke='#333333'
      strokeMiterLimit='10'
      strokeLinecap='square'
    />
  </svg>
))

export default MenuList


